import { isClient } from '@/utils/isClient';
export const isVideoPage = (): boolean => {
  if (!isClient()) {
    return false;
  }
  const path = window.location.pathname;
  return path.includes('/video');
};
